import { Button, Col, Descriptions, Row, Space } from 'antd';
import Link from 'antd/lib/typography/Link';
import styled from 'styled-components';

import { Contract } from '../../modules/contracts';
import { styledDescriptions } from '../styled/mixin';
import { priceToString } from '../../util/utils';

const StyledDiv = styled.div`
  ${styledDescriptions}
`;

interface PrimeContractDetailComponentProps {
  data: Contract;
  moveToContractEditPage: (contractId: number) => void;
  openPdfFile: (file: any) => void;
}

function PrimeContractDetailComponent({
  data,
  moveToContractEditPage,
  openPdfFile,
}: PrimeContractDetailComponentProps) {
  const attachedFileList = data.attachedFiles.map((file: any) => (
    <li key={file.id}>
      <Link
        onClick={(e) => {
          e.stopPropagation();
          openPdfFile(file);
        }}
      >
        {file.name}
      </Link>
    </li>
  ));

  const costList = data.priceData.isComplex
    ? data.priceData.priceData.directCosts.map((cost: any, index: number) => (
        <li key={index} style={{ listStyleType: 'none' }}>
          {cost.name} / {priceToString(cost.price)}
        </li>
      ))
    : null;

  return (
    <StyledDiv>
      <Row>
        <Col flex={1}>
          <Descriptions
            title="계약정보"
            bordered
            column={2}
            size="small"
            extra={
              <Space size="middle">
                <Button
                  onClick={(e) => moveToContractEditPage(data.id)}
                  data-test="go-contract-edit-page-btn"
                  size="small"
                >
                  수정
                </Button>
              </Space>
            }
          >
            <Descriptions.Item label="계약명">{data.title}</Descriptions.Item>
            <Descriptions.Item label="발주처명">
              {data.ownerName}
            </Descriptions.Item>
            <Descriptions.Item label="계약일">
              {data.contractDate}
            </Descriptions.Item>
            <Descriptions.Item label="공사시작일">
              {data.startDate}
            </Descriptions.Item>
            <Descriptions.Item label="공사종료일(예상)">
              {data.endDate}
            </Descriptions.Item>
            <Descriptions.Item label="설명" style={{ whiteSpace: 'pre-wrap' }}>
              {data.description}
            </Descriptions.Item>
            <Descriptions.Item label="계약 첨부 서류">
              {attachedFileList}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
      <Row style={{ marginTop: '30px' }}>
        <Col span={12}>
          {/* <Title level={5} style={{ marginTop: '50px' }}>
            내역서
          </Title> */}
          <Descriptions title="내역서" bordered column={1} size="small">
            {data.priceData.isComplex && (
              <>
                <Descriptions.Item
                  label="공사비 집계표"
                  labelStyle={{ width: '40%' }}
                  contentStyle={{ textAlign: 'right' }}
                >
                  {costList}
                </Descriptions.Item>
                <Descriptions.Item
                  label="공사비 합계 (A)"
                  contentStyle={{ textAlign: 'right' }}
                >
                  {priceToString(data.priceData.priceData.totalDirectCosts)}
                </Descriptions.Item>
                <Descriptions.Item
                  label="기타금액 합계 (B)"
                  contentStyle={{ textAlign: 'right' }}
                >
                  {priceToString(data.priceData.priceData.totalIndirectCosts)}
                </Descriptions.Item>
              </>
            )}
            {/* <Descriptions.Item
              label="순공사원가 합계 (C = A + B)"
              contentStyle={{ textAlign: 'right' }}
            >
              {priceToString(data.priceData.priceData.costTotal)}
            </Descriptions.Item>
            <Descriptions.Item
              label="일반관리비 (D)"
              contentStyle={{ textAlign: 'right' }}
            >
              {priceToString(data.priceData.priceData.administrativeExpense)}
            </Descriptions.Item>
            <Descriptions.Item
              label="이윤 (E)"
              contentStyle={{ textAlign: 'right' }}
            >
              {priceToString(data.priceData.priceData.profit)}
            </Descriptions.Item> */}
            <Descriptions.Item
              label={`공급가액 ${
                data.priceData.isComplex ? '(C = A + B)' : ''
              }`}
              contentStyle={{ textAlign: 'right' }}
            >
              {priceToString(data.priceData.priceData.supplyPrice)}
            </Descriptions.Item>
            <Descriptions.Item
              label="부가세"
              contentStyle={{ textAlign: 'right' }}
            >
              {priceToString(data.priceData.priceData.vat)}
            </Descriptions.Item>
            <Descriptions.Item
              label="총공사금액"
              contentStyle={{ textAlign: 'right' }}
            >
              {priceToString(data.priceData.priceData.totalPrice)}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
    </StyledDiv>
  );
}

export default PrimeContractDetailComponent;
